import { Control } from 'ol/control';
import GIS from "../app"
import { getRenderPixel } from 'ol/render';
import {SwipeOptions} from "../configuration/control";
import RenderEvent from "ol/render/Event";

class SwipeControl extends Control {
    private readonly GIS;
    private layerName: string | undefined;
    private toolOffset = 15;
    private swipeValue = 50;

    private readonly swipeTool;
    private readonly swipeDivider;
    private readonly swipeButton;
    private pos1: number;
    private pos2: number;

    constructor(GIS: GIS, opt_options?: SwipeOptions) {
        const element = document.createElement('div');

        super({
            element: element,
            target: opt_options && opt_options.target,
        });

        this.GIS = GIS;
        this.swipeTool = element;
        this.pos1 = 0;
        this.pos2 = 0;

        this.swipeButton = document.createElement('button');
        this.swipeButton.innerHTML = '<i class="fal fa-arrows-h"/>';
        this.swipeButton.className = 'cfm-swipe-button';
        this.swipeButton.type = 'button';

        this.swipeDivider = document.createElement('div');
        this.swipeDivider.className = 'cfm-swipe-divider';

        this.swipeTool.className = 'cfm-tool cfm-swipe ol-unselectable ol-control hidden';
        this.swipeTool.style.display = 'none';
        this.swipeTool.appendChild(this.swipeButton);
        this.swipeTool.appendChild(this.swipeDivider);


        this.dragElement(this.swipeTool);

        this.onPrerender = this.onPrerender.bind(this);
        this.onPostRender = this.onPostRender.bind(this);
        this.elementDrag = this.elementDrag.bind(this);
    }

    private onPostRender (event:RenderEvent) {
        const ctx = event.context  as CanvasRenderingContext2D;
        ctx.restore();
    };

    private onPrerender (event:RenderEvent) {
        const mapSize = this.GIS?.Map?.olObject?.getSize();

        const ctx = event.context as CanvasRenderingContext2D;
        if (mapSize && ctx) {
            const width = mapSize[0] * (this.swipeValue / 100);
            const tl = getRenderPixel(event, [width, 0]);
            const tr = getRenderPixel(event, [mapSize[0], 0]);
            const bl = getRenderPixel(event, [width, mapSize[1]]);
            const br = getRenderPixel(event, mapSize);

            ctx.save();
            ctx.beginPath();
            ctx.moveTo(tl[0], tl[1]);
            ctx.lineTo(bl[0], bl[1]);
            ctx.lineTo(br[0], br[1]);
            ctx.lineTo(tr[0], tr[1]);
            ctx.closePath();
            ctx.clip();
        }

        this.GIS?.Map?.olObject?.render();
    };

    private elementDrag(e:MouseEvent, element: HTMLElement) {
        e.preventDefault();
        this.pos1 = this.pos2 - e.clientX;
        this.pos2 = e.clientX;

        //Only horizontally
        const left = element.offsetLeft - this.pos1;
        element.style.left = left + "px";

        const mapSize = this.GIS.Map.olObject!.getSize();

        if (mapSize) {
            this.swipeValue = (left + this.toolOffset) * 100 / mapSize[0];
            this.GIS.Map.olObject!.render();
        }
    }

    private closeDragElement() {
        // stop moving when mouse button is released:
        document.onmouseup = null;
        document.onmousemove = null;
    }

    private dragMouseDown(e:MouseEvent, element: HTMLElement) {
        e.preventDefault();
        this.pos2 = e.clientX;
        document.onmouseup = () => this.closeDragElement();
        // call a function whenever the cursor moves:
        document.onmousemove = (event) => this.elementDrag(event, element);
    }

    private dragElement(element: HTMLElement) {
        const header = document.getElementById(element.id + "header");
        if (header) {
            // if present, the header is where you move the DIV from:
            header.onmousedown = (event) => this.dragMouseDown(event, element);
        } else {
            // otherwise, move the DIV from anywhere inside the DIV:
            element.onmousedown = (event) => this.dragMouseDown(event, element);
        }
    }

    private show() {
        this.swipeTool.style.display = 'flex';
    }

    private hide() {
        this.swipeTool.style.display = 'none';
    }

    public deactivate() {
        if (this.layerName) {
            const layer = this.GIS.Layer.getLayer(this.layerName);
            layer.un('prerender', this.onPrerender);
            layer.un('postrender', this.onPostRender);
            this.hide();
            this.layerName = undefined;
            this.swipeValue = 50;
        } else {
            throw Error("Swipe tool is not active.")
        }
    }

    public swipeLayer (name: string) {
        if (this.layerName) {
            throw Error("Cannot swipe more then one layer. You must deactivate first.")
        }

        const mapSize = this.GIS.Map.olObject!.getSize();

        if (mapSize) {
            this.swipeDivider.style.height = (mapSize[1] - 20) + 'px';

            const layer = this.GIS.Layer.getLayer(name)

            this.layerName = name;

            this.show();

            this.swipeTool.style.left = (mapSize[0] / 2 - this.toolOffset) + 'px';

            layer.on('prerender', this.onPrerender);
            layer.on('postrender', this.onPostRender);

            this.GIS.Map.olObject!.render();
        }
    };
}

export default SwipeControl;